module.exports = __webpack_public_path__ + "img/news_list_1.0acf9f0b.jpg";